var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlainEnglishSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18036_4938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0V15.3667H45.9533V2.03333H2.04667V37.3333H8.62V43.0433L14.3333 37.3333H17.41V39.38H15.18L6.57333 48V39.3933H0V0H48ZM38.94 10.0433H8.90333V12.0933H38.94V10.0433ZM8.90333 20.75H17.41V18.7033H8.90333V20.75ZM8.90333 29.38H17.41V27.3333H8.90333V29.38ZM40.3533 27.3333H29.3533V29.38H40.3533V27.3333ZM22.0467 18.7033H48V39.3933H41.7733V48L33.1667 39.3933H22.0467V18.7033ZM24.0933 37.3333H34L39.7133 43.0433V37.3333H45.94V20.75H24.0933V37.3333Z",
    fill: "#415385"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18036_4938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlainEnglishSummary);
export default __webpack_public_path__ + "static/media/plain-english-summary.cf329c3a811d90c75e7257da711ce695.svg";
export { ForwardRef as ReactComponent };